// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label___psx2","active":"Label_active__voopF","focus":"Label_focus__NF8S6","invalid":"Label_invalid__21a9Q"};